import * as ReactTabs from 'react-tabs';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Tabs = styled(ReactTabs.Tabs)``;

export const TabList = styled(ReactTabs.TabList)`
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    color: ${tokens.text.primary};
`;

export const Tab = styled(ReactTabs.Tab)`
    box-sizing: border-box;
    margin: 1rem;
    padding-bottom: 0.25rem;
    border-bottom: 2px solid transparent;
    font-weight: 500;
    cursor: pointer;

    &[aria-selected='true'] {
        border-color: ${tokens.primary.default};
        color: ${tokens.primary.default};
    }

    /* eliminate margins on first and last element to make it flush with sides */
    &:first-child {
        margin-left: 0;
    }
    &:last-child {
        margin-right: 0;
    }
`;

export const TabPanel = styled(ReactTabs.TabPanel)``;
